import { type RootState } from '../rmsStore';

export default function getReportReducer(state: RootState): ReportState {
  return state.reportsReducer;
}
